<template>
  <div class="each-reported-user-wrap">
    <div class="user-info">
      <img
        class="frame"
        :src="
          imageBaseUrl +
          'api/users/' +
          'pictureframe?ust_id=' +
          ust_id +
          '&type=circle' +
          '&sid=' +
          sid
        "
        draggable="false"
      />
      <div>
        <img :src="image" alt="user-avatar.jpg" />
      </div>

      <div class="info">
        <div>{{ $t("reports.user") + ": " + report.reported_user }}</div>
        <div>{{ $t("reports.reportedBy") + ": " + report.reported_by }}</div>
        <div>
          {{ $t("reports.reason") + ": " }}<strong>{{ report.reason }}</strong>
        </div>
      </div>
    </div>
    <div class="buttons-wrap">
      <div class="buttons-line">
        <button class="ban-button" @click="emitActionAndReportId('ban')">
          <div>{{ $t("button.banUser") }}</div>
          <div class="icon">
            <span class="material-icons">block</span>
          </div>
        </button>
        <button class="ignore-button" @click="emitActionAndReportId('ignore')">
          <div>{{ $t("button.ignore") }}</div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      image: "",
      imageBaseUrl: process.env.VUE_APP_VIDEO_BASE,
    };
  },
  props: {
    report: Object,
  },
  computed: {
    sid() {
      return localStorage.getItem("sid");
    },
    ust_id() {
      return localStorage.getItem("ust_id");
    },
  },
  mounted() {
    this.getUserAvatar();
  },
  methods: {
    async getUserAvatar() {
      try {
        this.startLoading();
        this.image = await this.getImageUsrId(this.report.usr_id);
      } catch (error) {
        this.handleError(error);
      }
      this.stopLoading();
    },
    emitActionAndReportId(action) {
      this.$emit("set-report-id", this.report.rpt_id);
      this.$emit(action);
    },
  },
};
</script>

<style scoped>
img {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  bottom: 0px;
  left: -60px;
}
.each-reported-user-wrap {
  display: flex;
  flex-direction: row;
  margin-bottom: 2%;
}
.user-info {
  display: flex;
  flex-direction: row;
  width: 70%;
  position: relative;
}
.frame {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 10%;
  width: 65%;
}
.info div {
  width: 100%;
}
.buttons-wrap {
  display: flex;
  align-items: center;
  width: 30%;
}
.buttons-line {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.buttons-line button {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;
  border: none;
  padding: 3% 5%;
  font-size: 0.8em;
  border-radius: 100px;
}
button:active,
button:focus {
  outline: none;
  border: none;
}
.ban-button {
  background: var(--button-color-blue);
  color: white;
}
.ignore-button {
  color: black;
  background: #ffffff;
}
.buttons-line {
  display: flex;
  justify-content: space-between;
}
.buttons-line .icon {
  display: flex;
  align-items: center;
  padding-left: 15px;
}
.icon span {
  font-size: 18px;
}
</style>